import { WithRef } from "@converge-collective/common/models/Base";
import { Network } from "@converge-collective/common/models/Network";
import { modelFromSnap } from "@converge-collective/common/util";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useFirestore, useUser } from "reactfire";

export default function useNetworkFromUrl(): WithRef<Network> | undefined {
  const [network, setNetwork] = useState<WithRef<Network>>();
  const router = useRouter();
  const firestore = useFirestore();
  const { data: user } = useUser();
  const networkToFetch = router?.query?.network;
  console.log("useNetworkFromUrl", { user, router, networkToFetch });

  useEffect(() => {
    const fetchNetwork = async () => {
      console.log("fetching network", { networkToFetch });
      // we can't perform a collection group query to look up the network by
      // slug because users can only read networks that they belong to

      // we use a different query to lookup the network for logged in users than
      // public users since logged in users have access to private networks that
      // they are members of
      if (user) {
        const profileRef = firestore.doc(`profiles/${user.uid}`);
        const query = firestore
          .collectionGroup("members")
          // filtering to networks that the current user is a member of
          .where("profileRef", "==", profileRef)
          .where("network.slug", "==", networkToFetch);
        console.log(`useNetwork fetch query for user ${user.uid}`, { query });
        const results = await query.get();
        if (!results.empty) {
          const [firstDoc] = results.docs;
          const networkRef = firstDoc.ref.parent?.parent;
          if (networkRef) {
            const network = modelFromSnap<Network>(await networkRef.get());
            console.log("useNetwork got network!", { network });
            setNetwork(network);
          }
          // setNetworkMembership({
          //   ...firstDoc.data(),
          //   networkPath,
          // } as NetworkMembership);
        }
      } else {
        // non-logged-in users can only view public networks
        const query = firestore
          .collectionGroup("networks")
          .where("public", "==", true)
          .where("slug", "==", networkToFetch);
        console.log("useNetwork fetch query for public user", { query });
        const results = await query.get();
        if (!results.empty) {
          const [firstDoc] = results.docs;
          const n = modelFromSnap<Network>(firstDoc);
          setNetwork(n);
        }
      }
    };
    networkToFetch && fetchNetwork();
  }, [user, networkToFetch, firestore]);

  return network;
}
